var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 74,
    viewBox: "0 0 58 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.8886 29.1591C57.8886 44.9526 45.0854 57.7558 29.292 57.7558C13.4985 57.7558 0.695312 44.9526 0.695312 29.1591C0.695312 13.3657 13.4985 0.5625 29.292 0.5625C45.0854 0.5625 57.8886 13.3657 57.8886 29.1591Z",
    fill: "url(#paint0_radial_1326_16644)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4533 36.1485C29.6247 36.0274 29.8518 36.0332 30.0172 36.1629L37.9726 42.3965C38.185 42.5629 38.2267 42.8758 38.0656 43.0954C37.9045 43.3149 37.6018 43.3579 37.3893 43.1915L29.7109 37.1749L21.1691 43.2059C20.949 43.3613 20.6486 43.3029 20.4982 43.0754C20.3479 42.8479 20.4044 42.5375 20.6245 42.3821L29.4533 36.1485Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0717 20.9414L15.8125 24.1188V40.0058L21.0717 37.305V20.9414Z",
    fill: "url(#paint1_linear_1326_16644)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.698 19.6568C22.8669 19.9375 22.7764 20.302 22.4957 20.471L14.9856 24.9923C14.7049 25.1612 14.3404 25.0707 14.1714 24.79C14.0025 24.5093 14.093 24.1448 14.3737 23.9758L21.8838 19.4546C22.1645 19.2856 22.529 19.3761 22.698 19.6568Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.194 20.9414L41.4531 24.1188V40.0058L36.194 37.305V20.9414Z",
    fill: "url(#paint2_linear_1326_16644)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7005 19.6568C34.5315 19.9375 34.6221 20.302 34.9027 20.471L42.4128 24.9923C42.6935 25.1612 43.058 25.0707 43.227 24.79C43.396 24.5093 43.3054 24.1448 43.0247 23.9758L35.5147 19.4546C35.234 19.2856 34.8695 19.3761 34.7005 19.6568Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9186 68.3898H29.6641V67.4296H39.9186V68.3898ZM38.9584 63.2813H30.6054V62.3086H38.9584V63.2813ZM38.9082 66.4192H30.6556V65.459H38.9082V66.4192ZM33.4295 66.0803H32.2434V62.7102H33.4295V66.0803ZM37.3205 66.0803H36.1281V62.7102H37.3205V66.0803ZM38.6697 73.015H30.8941V69.4504H38.6697V73.015ZM32.0739 72.0485H37.5025V70.3792H32.0739V72.0485Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0797 62.3591C24.0797 62.9825 23.8747 63.5452 23.4647 64.0473C23.0589 64.5493 22.5087 64.9635 21.8142 65.2899C21.1238 65.612 20.354 65.8275 19.5047 65.9363L19.0968 65.0389C19.8248 64.951 20.4921 64.7795 21.0987 64.5242C21.7054 64.2648 22.1844 63.9469 22.5359 63.5703C22.8915 63.1896 23.0693 62.7859 23.0693 62.3591V61.9951H24.0797V62.3591ZM24.2931 62.3591C24.2931 62.7859 24.4688 63.1896 24.8202 63.5703C25.1759 63.9469 25.657 64.2648 26.2637 64.5242C26.8703 64.7795 27.5376 64.951 28.2656 65.0389L27.8514 65.9363C27.0063 65.8275 26.2344 65.6099 25.5357 65.2836C24.8412 64.9573 24.2889 64.5452 23.8789 64.0473C23.4689 63.5452 23.2639 62.9825 23.2639 62.3591V61.9951H24.2931V62.3591ZM28.8053 67.524H18.5508V66.545H28.8053V67.524ZM27.5063 71.1263H20.9669V72.3501H19.7934V70.2665H26.339V69.344H19.7745V68.4403H27.5063V71.1263ZM27.8326 73.0467H19.7934V72.1242H27.8326V73.0467Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1326_16644",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.292 29.1591) rotate(90) scale(28.5966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1FBE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1326_16644",
    x1: 18.4421,
    y1: 20.9414,
    x2: 18.4421,
    y2: 40.0058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79C7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D99FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1326_16644",
    x1: 38.8235,
    y1: 20.9414,
    x2: 38.8235,
    y2: 40.0058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79C7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D99FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/Sad.3cbaf09259ced5d13151bf6a3dfb4c00.svg";
export { ForwardRef as ReactComponent };